import moment from "moment"
import React from "react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import { Button } from "semantic-ui-react"


const formatDate = date => {
  return moment( date ).format( "DD. MMMM YYYY" )
}


const DeliveryDatePicker = ( { onChange, date } ) => {
  const MIN_DELAY = 0
  return <div className={"pb2 pt2"}>
    <div className="pb2 ">
      {date &&
      <div>{moment( date, "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</div>}
    </div>
    <DayPickerInput 
      style={{zIndex: "999"}}
      value={date}
      placeholder={translate("Ihr Terminwunsch")}
      formatDate={formatDate}
      dayPickerProps={{
        initialMonth: moment().add( MIN_DELAY, "day" ).toDate(),
        disabledDays: [
          {
            before: moment().add( MIN_DELAY, "day" ).toDate()
          }
        ]
      }}
      onDayChange={onChange}/>
    {date && <div className="dib pl3"><Button basic icon="close"
                                              onClick={() => onChange( "" )}/>
    </div>}
  </div>
}

export default DeliveryDatePicker


// WEBPACK FOOTER //
// ./src/components/Date/DeliveryDatePicker.js